import { CustomComponentProps } from "utils/types/generalTypes";
import SVG from "../core/SVG";

import userPlaceHolder from "assets/img/user_icon.png";
import { ChatMsgObj } from "assets/data/chatData";

export type SendedMsgProps = CustomComponentProps & {
    msg: ChatMsgObj;
    setPreviewImg: React.Dispatch<React.SetStateAction<string | undefined>>;
};

import { useLongPress } from "use-long-press";
import { useRef, useState } from "react";
import { useOnClickOutside } from "usehooks-ts";

const SendedMsg = ({
    msg,
    setPreviewImg,
    className,
    style
}: SendedMsgProps) => {
    const [showDropdown, setShowDropDown] = useState(false);
    const dropdownRef = useRef(null);
    useOnClickOutside(dropdownRef, () => setShowDropDown(false));

    const bind = useLongPress(() => {
        // alert("Long pressed!");
        setShowDropDown(true);
    });

    return (
        <>
            <div
                className={`sender-msg chat-msg d-flex flex-row-r flex-j-end flex-a-end gap-5 ${className}`}
                style={style}
            >
                <div className="msg-pic-col d-flex flex-col gap-5 flex-j-end flex-a-center">
                    <SVG
                        svg={msg.read ? "double-check" : "check"}
                        className={msg.read ? "blue-svg" : ""}
                    />
                    <img
                        src={msg.user.url || userPlaceHolder}
                        alt={msg.user.name}
                    />
                </div>
                <div className="d-flex flex-col flex-j-end flex-a-end gap-5 w-full p-relative">
                    {msg.msg ? (
                        // <div p->
                        <div className="chat-msg-div p-relative" {...bind()}>
                            {msg.msg}
                        </div>
                    ) : (
                        // </div>
                        <img
                            src={msg.img}
                            alt="img"
                            className="chat-msg-img cursor-pointer"
                            {...bind()}
                            onClick={() => setPreviewImg(msg.img)}
                        />
                    )}
                    <div className="time">{msg.time}</div>
                    <div
                        className={`${!showDropdown && "is-hidden"}  my-dropdown left box-shadow cursor-default `}
                        ref={dropdownRef}
                    >
                        <div className="drop-item cursor-pointer">
                            Delete Message
                        </div>
                    </div>
                </div>
            </div>

            {/* preview Img */}
        </>
    );
};

export default SendedMsg;
